/* jshint esversion: 6 */
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { MyContext } from "../../Context/MyProvider";
import { showToast } from "../../showTost";

export default function LabTestsBrowse() {
  const { ApiBaseUrl } = useContext(MyContext);
  const navigate = useNavigate();
  const [tests, setTests] = useState([]);
  const [search, setSearch] = useState("");
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    axios.get(`${ApiBaseUrl}/api/v1/lab/tests`, { params: { search, limit: 40 } })
      .then((res) => { if (res.data.success) setTests(res.data.tests || []); })
      .catch(() => showToast({ title: "Could not load tests", id: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggle = (t) => {
    setCart((c) => c.find((x) => x.test_id === t.test_id) ? c.filter((x) => x.test_id !== t.test_id) : [...c, { test_id: t.test_id, name: t.test_name, price: t.price }]);
  };

  const continueFlow = () => {
    if (!cart.length) {
      showToast({ title: "Select at least one test", id: "warning" });
      return;
    }
    sessionStorage.setItem("lab_tests_cart", JSON.stringify(cart));
    navigate("/lab-tests/slots");
  };

  return (
    <div className="width-container py-8 pb-28">
      <p className="text-sm text-rm-primary font-medium mb-2">Hyderabad home collection · Reports in Health Records</p>
      <h1 className="text-2xl font-bold mb-4">Book lab tests</h1>
      <p className="text-gray-600 mb-4">Browse tests first — we assign a verified phlebotomist automatically. No need to pick a lab brand.</p>
      <div className="flex gap-2 mb-6">
        <input className="flex-1 border rounded-lg px-4 py-3" placeholder="Search CBC, thyroid…" value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
        <button type="button" className="rm-btn-primary px-6" onClick={load} disabled={loading}>{loading ? "…" : "Search"}</button>
      </div>
      <div className="grid md:grid-cols-2 gap-4 mb-8">
        {tests.map((t) => (
          <div key={t.test_id} className={`border rounded-xl p-4 cursor-pointer bg-white ${cart.find((c) => c.test_id === t.test_id) ? "ring-2 ring-rm-primary" : ""}`} onClick={() => toggle(t)}>
            <h3 className="font-semibold">{t.test_name}</h3>
            <p className="text-sm text-gray-500">{t.test_code} · {t.sample_type}</p>
            <p className="text-rm-primary font-bold mt-2">₹{t.price}</p>
            <p className="text-xs">TAT {t.turnaround_time_hours}h {t.fasting_required ? "· Fasting required" : ""}</p>
          </div>
        ))}
      </div>
      {cart.length > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 shadow-lg z-[1300]">
          <div className="width-container flex justify-between items-center gap-4">
            <span className="font-medium">{cart.length} test(s) selected</span>
            <button type="button" className="rm-btn-primary px-6 py-3 min-w-[140px]" onClick={continueFlow}>Choose slot</button>
          </div>
        </div>
      )}
      <Link to="/lab-details" className="text-sm text-gray-500 underline">Legacy lab browse</Link>
    </div>
  );
}
